/**
 * @author Harshitha.k
 * @description 
 */

import React, { useState, useEffect } from 'react';
import { SelectDropDown } from './CSS/styles.js';
import TagInputWidget from './Widgets/Selection/TagInputWidget';
import ColorInputWidget from './Widgets/Selection/ColorInputWidget';
import { defaultGraphTypeProps, graphTypeList } from './DefaultGraphTypeProps';
import { DeleteOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import {
  Checkbox,
  Input,
  Select,
  Radio,
  Button,
  Form,
  Drawer,
  InputNumber,
  Tooltip,
  Tabs
} from 'antd';
import SelectAPI from './Widgets/Selection/SelectAPI.js';

const Option = Select.Option;

const ConfigurationModalContent = ({ open, onCancel, onOk, editData }) => {
  const [state, setState] = useState({
    title: '',
    graph: '',
    type: 'historic',
    GraphLevelSelection: 'none',
    GraphLevelSelectionPoint: 'PreviousDay',
    GraphLevelTimeBucket: '',
    activeKey: '1',
    query: '',
    queryData: [],
    warningList: [],
    refreshTime: '',
    checked: false,
    enableExcel: false,
    num: '',
    inputGraphFields: {
      Day: '',
      Week: '',
      Month: '',
      Year: ''
    },
    TimeBucketKey: true,
    apiPayloadCount: {},
    apiPayloadData: {},
    deviceMultiSelect: false,
    apiPayloadDeviceSelection: {},
    deviceGraphSelection: "false",
    // GraphDeviceSelection:"deviceSelection"
  });

  useEffect(() => {
    if (editData && editData.length > 0) {
      setState({
        ...state,
        ...editData[0],
        [editData[0].graph]: editData[0][editData[0].graph]
      });
    }
  }, [editData]);

  const renderWidget = (graphTypeProps, index) => {
    const { graph, num } = state;
    switch (graphTypeProps.Widget) {
      case 'Input':
        return num === 'string' && graphTypeProps.DisplayName === 'xAxisDateFormat' || graphTypeProps.DisplayName === "Device Code/Name" && num === "static" ? null : (
          <Form.Item key={index} label={graphTypeProps.DisplayName} required="true">
            <Input
              value={state[graph]?.[graphTypeProps.Key] || ''}
              onChange={(e) =>
                setState(prevState => ({
                  ...prevState,
                  [graph]: {
                    ...prevState[graph],
                    [graphTypeProps.Key]: e.target.value
                  }
                }))
              }
            />
          </Form.Item>
        );
      case 'Number':
        return num === 'string' && graphTypeProps.DisplayName === 'Interval' ? null : (
          <Form.Item key={index} label={graphTypeProps.DisplayName}>
            <InputNumber
              value={state[graph]?.[graphTypeProps.Key] || ''}
              onChange={(e) =>
                setState(prevState => ({
                  ...prevState,
                  [graph]: {
                    ...prevState[graph],
                    [graphTypeProps.Key]: e
                  }
                }))
              }
            />
          </Form.Item>
        );
      case 'TextArea':
        return (
          <Form.Item key={index} label={graphTypeProps.DisplayName}>
            <Input.TextArea
              rows={3}
              value={state[graph]?.[graphTypeProps.Key] || ''}
              onChange={(e) =>
                setState(prevState => ({
                  ...prevState,
                  [graph]: {
                    ...prevState[graph],
                    [graphTypeProps.Key]: e.target.value
                  }
                }))
              }
            />
          </Form.Item>
        );
      case 'Select':
        return (
          <Form.Item key={index} label={graphTypeProps.DisplayName} required="true">
            <Select
              value={state[graph]?.[graphTypeProps.Key] || ''}
              onChange={(value) => {
                setState(prevState => ({
                  ...prevState,
                  [graph]: {
                    ...prevState[graph],
                    [graphTypeProps.Key]: value
                  },
                  num: value
                }));
              }}
            >
              {graphTypeProps.Options && Array.isArray(graphTypeProps.Options) &&
                graphTypeProps.Options.map((optionObject, index) => (
                  <Option key={index} value={optionObject}>
                    {optionObject}
                  </Option>
                ))}
            </Select>
          </Form.Item>
        );
      case 'SelectAPI':
        return (
          <Form.Item key={index} label={graphTypeProps.DisplayName}>
            <SelectAPI
              api={graphTypeProps.Api}
              value={state[graph]?.[graphTypeProps.Key] || ''}
              handleFieldChange={(value) => {
                setState(prevState => ({
                  ...prevState,
                  [graph]: {
                    ...prevState[graph],
                    [graphTypeProps.Key]: value
                  },
                  num: value
                }));
              }}
            />

          </Form.Item>
        );
      case 'TagList':
        return (
          <Form.Item key={index} label={graphTypeProps.DisplayName}>
            <TagInputWidget
              graphTypeProps={graphTypeProps}
              value={state[graph]?.[graphTypeProps.Key] || ''}
              addedTagList={(e) => addedTagList(e, graphTypeProps.Key)}
            />
          </Form.Item>
        );
      case 'ColorList':
        return (
          <Form.Item key={index} label={graphTypeProps.DisplayName}>
            <ColorInputWidget
              graphTypeProps={graphTypeProps}
              value={state[graph]?.[graphTypeProps.Key] || ''}
              addedTagList={(e) => addedTagList(e, graphTypeProps.Key)}
            />
          </Form.Item>
        );
      default:
        return <div key={index}></div>;
    }
  };

  const addedTagList = (valueList, key) => {
    setState(prevState => ({
      ...prevState,
      [prevState.graph]: {
        ...prevState[prevState.graph],
        [key]: valueList
      }
    }));
  };

  const addNextQuery = () => {
    setState(prevState => ({
      ...prevState,
      queryData: [...prevState.queryData, prevState.queryData.length + 1]
    }));
  };

  const handleRemoveFields = (keyName) => {
    setState(prevState => {
      const updatedFields = { ...prevState.inputGraphFields };
      delete updatedFields[keyName];
      return { ...prevState, inputGraphFields: updatedFields };
    });
  };

  const handleInputChange = (event, item) => {
    setState(prevState => ({
      ...prevState,
      inputGraphFields: {
        ...prevState.inputGraphFields,
        [item]: event.target.value
      }
    }));
  };

  const resetTimeBucket = () => {
    setState(prevState => ({
      ...prevState,
      inputGraphFields: {
        Day: '',
        Week: '',
        Month: '',
        Year: '',
        ...prevState.inputGraphFields
      }
    }));
  };

  const selectMethodAlertsData = (value) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadData: {
        ...prevState.apiPayloadData,
        method: value,
        ...(prevState && prevState.apiPayloadData && prevState.apiPayloadData.method === 'POST' ? { payload: prevState.apiPayloadData.payload } : {})
      }
    }));
  };

  const enterURLAlertsData = (e) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadData: {
        ...prevState.apiPayloadData,
        url: e.target.value,
        method: prevState.apiPayloadData.method || '',
        ...(prevState && prevState.apiPayloadData && prevState.apiPayloadData.method === 'POST' ? { payload: prevState.apiPayloadData.payload } : {})
      }
    }));
  };

  const selectPayloadAlertsData = (e) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadData: {
        ...prevState.apiPayloadData,
        payload: JSON.parse(e.target.value)
      }
    }));
  };

  const selectGetparamsAlertsData = (e) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadData: {
        ...prevState.apiPayloadData,
        GETParams: e.target.value
      }
    }));
  };

  const selectMethodDeviceSelection = (value) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadDeviceSelection: {
        ...prevState.apiPayloadDeviceSelection,
        method: value,
        ...(prevState && prevState.apiPayloadDeviceSelection && prevState.apiPayloadDeviceSelection.method === 'POST' ?
          { payload: prevState && prevState.apiPayloadDeviceSelection && prevState.apiPayloadDeviceSelection.payload } : {})
      }
    }));
  };

  const enterURLAlertsDeviceSelection = (e) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadDeviceSelection: {
        ...prevState.apiPayloadDeviceSelection,
        url: e?.target?.value || '',
        method: prevState.apiPayloadDeviceSelection?.method || '',
        ...(prevState && prevState.apiPayloadDeviceSelection && prevState.apiPayloadDeviceSelection.method === 'POST' ?
          { payload: prevState && prevState.apiPayloadDeviceSelection && prevState.apiPayloadDeviceSelection.payload } : {})
      }
    }));
  };



  const selectPayloadDeviceSelection = (e) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadDeviceSelection: {
        ...prevState.apiPayloadDeviceSelection,
        payload: JSON.parse(e.target.value)
      }
    }));
  };

  const selectGetparamsDeviceSelection = (e) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadDeviceSelection: {
        ...prevState.apiPayloadDeviceSelection,
        GETParams: e.target.value
      }
    }));
  };

  const selectMethodAlertsCount = (value) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadCount: {
        ...prevState.apiPayloadCount,
        method: value,
        ...(prevState && prevState.apiPayloadCount && prevState.apiPayloadCount.method === 'POST' ?
          { payload: prevState && prevState.apiPayloadCount && prevState.apiPayloadCount.payload } : {})
      }
    }));
  };

  const enterURLAlertsCount = (e) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadCount: {
        ...prevState.apiPayloadCount,
        url: e.target.value,
        method: prevState.apiPayloadCount.method || '',
        ...(prevState && prevState.apiPayloadCount && prevState.apiPayloadCount.method === 'POST' ?
          { payload: prevState && prevState.apiPayloadCount && prevState.apiPayloadCount.payload } : {})
      }
    }));
  };

  const selectPayloadAlertsCount = (e) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadCount: {
        ...prevState.apiPayloadCount,
        payload: JSON.parse(e.target.value)
      }
    }));
  };

  const selectGetparamsAlertsCount = (e) => {
    setState(prevState => ({
      ...prevState,
      apiPayloadCount: {
        ...prevState.apiPayloadCount,
        GETParams: e.target.value
      }
    }));
  };

  const {
    activeKey,
    graph,
    title,
    refreshTime,
    checked,
    type,
    GraphLevelTimeBucket,
    GraphLevelSelectionPoint,
    GraphLevelSelection,
    queryData,
    inputGraphFields,
    TimeBucketKey
  } = state;

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 8 }
    }
  };

  const items = [
    {
      key: '1',
      label: 'Config',
      children: (
        <div style={{ marginTop: "10px" }}>
          <Form {...formItemLayout}>
            <Form.Item label="Panel Name">
              <Input
                type="text"
                value={title}
                onChange={(e) => setState(prevState => ({ ...prevState, title: e.target.value }))}
              />
            </Form.Item>
            <Form.Item label="Graph Type">
              <SelectDropDown
                onChange={(graph) => setState(prevState => ({ ...prevState, graph }))}
                value={graph}
              >
                {graphTypeList && Array.isArray(graphTypeList) &&
                  graphTypeList.map((graphType, index) => (
                    <Option key={index} value={graphType.value}>
                      {graphType.key}
                    </Option>
                  ))}
              </SelectDropDown>
            </Form.Item>
            <Form.Item label="Type">
              <Radio.Group
                value={type}
                onChange={(e) => setState(prevState => ({ ...prevState, type: e.target.value }))}
              >
                <Radio.Button value="live">Live</Radio.Button>
                <Radio.Button value="historic">Historic</Radio.Button>
                <Radio.Button value="summary">Summary</Radio.Button>
              </Radio.Group>
            </Form.Item>
            <Form.Item label="GraphLevel Selection Type">
              <Select
                value={GraphLevelSelection}
                onChange={(val) => {
                  setState(prevState => ({
                    ...prevState,
                    GraphLevelSelection: val,
                    TimeBucketKey: val === 'none',
                    GraphLevelTimeBucket: '1h'
                  }));
                }}
              >
                {type === 'live' ? (
                  <>
                    <Option value="deviceSelection">Device Selection</Option>
                    <Option value="none">None</Option>
                  </>
                ) : (
                  <>
                    <Option value="datePicker">Date Selection</Option>
                    <Option value="dateRangePicker">DateRange Selection</Option>
                    <Option value="monthPicker">Month Selection</Option>
                    <Option value="dateMonthYearPicker">DayMonthYear Selection</Option>
                    {/* <Option value="deviceSelection">Device Selection</Option> */}
                    <Option value="none">None</Option>
                  </>
                )}
              </Select>
            </Form.Item>

            {GraphLevelSelection && GraphLevelSelection !== 'none'  && (
              <>
                {GraphLevelSelection === 'dateMonthYearPicker' ? (
                  <div>
                    {inputGraphFields &&
                      Object.keys(inputGraphFields) &&
                      Object.keys(inputGraphFields).length > 0 ?
                      Object.keys(inputGraphFields).map((item, index) => (
                        <div key={index}>
                          <Form.Item label={item}>
                            <input
                              style={{ width: '150px' }}
                              type="text"
                              value={inputGraphFields[item]}
                              onChange={(e) => handleInputChange(e, item)}
                            />
                            <MinusCircleOutlined
                              style={{ marginLeft: '20px' }}
                              onClick={() => handleRemoveFields(item)}
                            />
                            {index === 0 ? (
                              <Tooltip title={'Add Other Selections'}>
                                <PlusOutlined
                                  style={{ color: 'green', marginLeft: '20px' }}
                                  onClick={resetTimeBucket}
                                />
                              </Tooltip>
                            ) : null}
                          </Form.Item>
                        </div>
                      )) : (
                        <Tooltip title={'Add Other Selections'}>
                          <PlusOutlined
                            style={{ color: 'green', marginLeft: '20px' }}
                            onClick={resetTimeBucket}
                          />
                        </Tooltip>
                      )}
                  </div>
                ) : (
                  <Form.Item label="Time Bucket">
                    <Select
                      value={GraphLevelTimeBucket}
                      onChange={(value) => setState(prevState => ({ ...prevState, GraphLevelTimeBucket: value }))}
                      disabled={TimeBucketKey}
                    >
                      <Option value="1m">1 Minute (1m)</Option>
                      <Option value="1h">1 Hour (1h)</Option>
                      <Option value="1d">1 Day (1d)</Option>
                      <Option value="1week">1 Week (1week)</Option>
                      <Option value="1month">1 Month (1month)</Option>
                      <Option value="1y">1 Year (1y)</Option>
                      <Option value="none">None</Option>
                    </Select>
                  </Form.Item>
                )}

                <Form.Item label="GraphLevel Selection EndPoint">
                  <Select
                    value={GraphLevelSelectionPoint}
                    onChange={(e) => setState(prevState => ({ ...prevState, GraphLevelSelectionPoint: e }))}
                  >
                    <Option value="PreviousDay">Previous Day</Option>
                    <Option value="CurrentDay">Current Day</Option>
                  </Select>
                </Form.Item>
              </>
            )}  
             <Form.Item label="Graph Device Selection">
                <Checkbox
                  checked={state.deviceGraphSelection === 'true'}
                  onChange={() => checkboxOnChange('true')}
                >
                  True
                </Checkbox>
                <Checkbox
                  checked={state.deviceGraphSelection === 'false'}
                  onChange={() => checkboxOnChange('false')}
                >
                  False
                </Checkbox>
              {/* </Form.Item> */}
              {state.deviceGraphSelection === 'true' ? (
                <div>
                  <Form.Item>
                    <Select
                      value={
                        state && state.apiPayloadDeviceSelection && state.apiPayloadDeviceSelection.method
                          ? state.apiPayloadDeviceSelection.method :
                          ''}
                      style={{ width: '200px' }}
                      placeholder={'Select Method'}
                      onChange={selectMethodDeviceSelection}
                    >
                      <Option value="GET">GET</Option>
                      <Option value="POST">POST</Option>
                    </Select>
                    <Input
                      style={{ width: '300px' }}
                      value={state && state.apiPayloadDeviceSelection && state.apiPayloadDeviceSelection.url || ''}
                      placeholder="Enter URL"
                      onChange={enterURLAlertsDeviceSelection}
                    />
                    {state && state.apiPayloadDeviceSelection && state.apiPayloadDeviceSelection.method === 'POST' ? (
                      <Input.TextArea
                        style={{ width: '300px' }}
                        defaultValue={
                          state &&
                            state.apiPayloadDeviceSelection &&
                            state.apiPayloadDeviceSelection.payload
                            ? JSON.stringify(state.apiPayloadDeviceSelection.payload)
                            : ''}
                        placeholder="Enter payload"
                        onBlur={selectPayloadDeviceSelection}
                      />
                    ) : null}
                    {state && state.apiPayloadDeviceSelection && state.apiPayloadDeviceSelection.method === 'GET' ? (
                      <Input.TextArea
                        style={{ width: '300px' }}
                        defaultValue={state &&
                          state.apiPayloadDeviceSelection &&
                          state.apiPayloadDeviceSelection.GETParams
                          ? state.apiPayloadDeviceSelection.GETParams :
                          ''}
                        placeholder="Enter GETParams"
                        onBlur={selectGetparamsDeviceSelection}
                      />
                    ) : null}
                  </Form.Item>
                </div>
              ) : null}
              </Form.Item>
              {state.deviceGraphSelection === 'true' && (
                <Form.Item label="Multi-Select">
                  <Checkbox
                    checked={state.deviceMultiSelect}
                    onChange={(e) => setState(prevState => ({ ...prevState, deviceMultiSelect: e.target.checked }))}
                  />
                </Form.Item>
              )}

            {graph && graph === 'DonutCounter' ? (
              <div>
                <Form.Item label="Alerts Data">
                  <Select
                    value={state && state.apiPayloadData && state.apiPayloadData.method ? state.apiPayloadData.method : ''}
                    style={{ width: '200px' }}
                    placeholder={'Select Method'}
                    onChange={selectMethodAlertsData}
                  >
                    <Option value="GET">GET</Option>
                    <Option value="POST">POST</Option>
                  </Select>
                  <Input
                    style={{ width: '300px' }}
                    value={state && state.apiPayloadData && state.apiPayloadData.url ? state.apiPayloadData.url : ''}
                    placeholder="Enter URL"
                    onChange={enterURLAlertsData}
                  />
                  {state && state.apiPayloadData && state.apiPayloadData.method === 'POST' && (
                    <Input.TextArea
                      style={{ width: '300px' }}
                      defaultValue={state.apiPayloadData.payload ? JSON.stringify(state.apiPayloadData.payload) : ''}
                      placeholder="Enter payload"
                      onBlur={selectPayloadAlertsData}
                    />
                  )}
                  {state && state.apiPayloadData && state.apiPayloadData.method === 'GET' && (
                    <Input.TextArea
                      style={{ width: '300px' }}
                      defaultValue={state && state.apiPayloadData && state.apiPayloadData.GETParams ? state.apiPayloadData.GETParams : ''}
                      placeholder="Enter GETParams"
                      onBlur={selectGetparamsAlertsData}
                    />
                  )}
                </Form.Item>

                <Form.Item label="Alerts Count">
                  <Select
                    value={state && state.apiPayloadCount && state.apiPayloadCount.method ? state.apiPayloadCount.method : ''}
                    style={{ width: '200px' }}
                    placeholder={'Select Method'}
                    onChange={selectMethodAlertsCount}
                  >
                    <Option value="GET">GET</Option>
                    <Option value="POST">POST</Option>
                  </Select>
                  <Input
                    style={{ width: '300px' }}
                    value={state && state.apiPayloadCount && state.apiPayloadCount.url ? state.apiPayloadCount.url : ''}
                    placeholder="Enter URL"
                    onChange={enterURLAlertsCount}
                  />
                  {state && state.apiPayloadCount && state.apiPayloadCount.method && state.apiPayloadCount.method === 'POST' && (
                    <Input.TextArea
                      style={{ width: '300px' }}
                      defaultValue={state.apiPayloadCount.payload ? JSON.stringify(state.apiPayloadCount.payload) : ''}
                      placeholder="Enter payload"
                      onBlur={selectPayloadAlertsCount}
                    />
                  )}
                  {state && state.apiPayloadCount && state.apiPayloadCount.method && state.apiPayloadCount.method === 'GET' && (
                    <Input.TextArea
                      style={{ width: '300px' }}
                      defaultValue={state && state.apiPayloadData && state.apiPayloadData.GETParams ? state.apiPayloadCount.GETParams : ''}
                      placeholder="Enter GETParams"
                      onBlur={selectGetparamsAlertsCount}
                    />
                  )}
                </Form.Item>
              </div>
            ) : null}

            {defaultGraphTypeProps[graph] && Array.isArray(defaultGraphTypeProps[graph]) &&
              defaultGraphTypeProps[graph].map((graphTypeProps, index) => renderWidget(graphTypeProps, index))}

            <Form.Item label="Refresh Time">
              <Input
                type="text"
                value={refreshTime}
                disabled={type === 'live' ? false : true}
                onChange={(e) => setState(prevState => ({ ...prevState, refreshTime: e.target.value }))}
              />
            </Form.Item>

            <Form.Item label=" ">
              <Checkbox
                checked={checked}
                onChange={(e) => setState(prevState => ({ ...prevState, checked: e.target.checked }))}
              >
                Refresh TimeStamp
              </Checkbox>
            </Form.Item>
          </Form>
        </div>
      ),
    },
    {
      key: '2',
      label: 'Query',
      children: (
        <div style={{ marginTop: "10px" }}>
          <Checkbox
            checked={state.queryRowsToColumns}
            onChange={(value) => setState(prevState => ({ ...prevState, queryRowsToColumns: value.target.checked }))}
          >
            Query RowsToColumns
          </Checkbox>
          <Checkbox
            checked={state.enableMock}
            onChange={(value) => setState(prevState => ({ ...prevState, enableMock: value.target.checked }))}
          >
            Enable mock
          </Checkbox>
          <Checkbox
            checked={state.enableWarningsOnFS}
            onChange={(value) => setState(prevState => ({ ...prevState, enableWarningsOnFS: value.target.checked }))}
          >
            Enable Warning On Fullscreen
          </Checkbox>

          {state.enableWarningsOnFS && (
            <Input.TextArea
              style={{ marginTop: '10px', width: '80%' }}
              placeholder="Input DeviceTag Data (Ex:[{parameterName:pn1, device: d1,parameter:p1}] )"
              autosize={{ minRows: 4 }}
              onChange={(e) => setState(prevState => ({ ...prevState, warningList: e.target.value }))}
              value={state.warningList}
            />
          )}

          <Input.TextArea
            style={{ marginTop: '10px', width: '100%' }}
            placeholder="Query"
            autosize={{ minRows: 4 }}
            onChange={(e) => setState(prevState => ({ ...prevState, query: e.target.value }))}
            value={state.query}
          />
          <div>
            {queryData && queryData.length < 2 && (
              <Button type="primary" style={{ marginTop: '5px' }} onClick={addNextQuery}>
                Add Query
              </Button>
            )}
          </div>

          {queryData && Array.isArray(queryData) && queryData.map((queryIndex, index) => (
            <div key={index}>
              <Input.TextArea
                style={{ marginTop: '10px', width: '80%' }}
                placeholder={`Query ${queryIndex}`}
                autosize={{ minRows: 4 }}
                onChange={(e) => setState(prevState => ({ ...prevState, [`query${queryIndex}`]: e.target.value }))}
                value={state[`query${queryIndex}`]}
              />
              <DeleteOutlined
                onClick={() => {
                  setState(prevState => ({
                    ...prevState,
                    queryData: prevState.queryData.filter(q => q !== queryIndex)
                  }));
                }}
              />
            </div>
          ))}
        </div>
      ),
    }
  ];

  let defaultProps = {
    activeKey: '1',
    title: '',
    graph: '',
    type: '',
    GraphLevelSelection: '',
    GraphLevelSelectionPoint: 'PreviousDay',
    GraphLevelTimeBucket: '',
    query: '',
    queryData: [],
    queryRowsToColumns: false,
    enableMock: false,
    enableWarningsOnFS: false,
    warningList: [],
    refreshTime: '',
    checked: true,
    inputGraphFields: {
      Day: '',
      Week: '',
      Month: '',
      Year: ''
    },
    apiPayloadCount: {},
    apiPayloadData: {},
    // GraphDeviceSelection:"deviceSelection"
  };

  const checkboxOnChange = (value) => {
    if (value === "true") {
      setState({ ...state,deviceGraphSelection: value });
    } else {
      setState({ ...state,deviceGraphSelection: value });
    }
  };

  return (
    <Drawer
      width={1200}
      closable
      title="Panel Configuration"
      open={open}
      onClose={onCancel}
    >
      <Tabs
        activeKey={activeKey}
        onChange={(activeKey) => setState(prevState => ({ ...prevState, activeKey }))}
        items={items}
      />
      <div style={{
        position: 'absolute',
        left: '0',
        bottom: '0',
        width: '100%',
        textAlign: 'center',
        paddingBottom: '10px'
      }}>
        <Button
          style={{ marginRight: 8 }}
          onClick={() => {
            onOk(state);
            setState({
              ...defaultProps
            });
          }}
          type="primary"
        >
          Save
        </Button>
        <Button
          type="primary"
          onClick={() => {
            onCancel();
            setState({
              ...defaultProps
            });
          }}
        >
          Close
        </Button>
      </div>
    </Drawer>
  );
};

export default ConfigurationModalContent;
